const getOverriddenExternalLinks = (state: AnyFixMe) =>
  state.externalLinks.overridden;

export { getOverriddenExternalLinks };
